<!--发布课程管理-->
<template>
  <div class="app-container2">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 0px;">
        <el-form :inline="true" label-width="140px" style="margin-bottom: -20px;">
          <el-form-item label="未来几天:">
            <!-- <el-checkbox-group style="margin-left: 10px; margin-top: 2px;" @change="checkedDayChanged"
              v-model="checkedDay" :min="0" :max="1">
              <el-checkbox v-for="day in redioWeek" :label="day.day" :key="day.day" style="font-size: 16px;">{{
                day.weekDay
              }}</el-checkbox>
            </el-checkbox-group> -->
            <el-radio-group v-model="radio" @change="checkedDayChanged">
              <span v-for="(item, i) in redioWeek" :key="i" style="margin-right: 5px;">
                <el-radio :label="i">{{ item.weekDay }}</el-radio>
              </span>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上课时间:">
            <el-date-picker @change="changesd" v-model="queryParam.dayTime" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
          @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
          询</el-button>
      </div>
    </el-card>
    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
          @click="clickvisibleDlgAdd()">临时加课</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
          @click="showVisibleDlgUpdateLesson()">修改课程信息</el-button>
        <el-button type="warning" class="operator-btn2" icon="el-icon-refresh-left" @click="handleRevoke()">撤销</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
          @click="correctBookNum()">刷新</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData" style="width: 100%" :data="tableData" max-height="510" v-loading="listLoading" border
        highlight-current-row :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }"
        @row-click="rowClick" @selection-change="handleSelectionChange">
        <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
        <el-table-column prop="lessonName" label="课程名"></el-table-column>
        <!--<el-table-column prop="minBookLevel" label="预约等级" ></el-table-column>-->
        <!--<el-table-column prop="canBookStartTime" label="预约起始时间" ></el-table-column>-->
        <!--<el-table-column prop="canBookEndTime" label="预约结束时间" ></el-table-column>-->
        <el-table-column prop="classStartTime" label="上课时间"></el-table-column>
        <el-table-column prop="classEndTime" label="下课时间"></el-table-column>
        <el-table-column prop="releaseTime" label="发布时间"></el-table-column>
        <el-table-column prop="maxBookPeople" label="总课容量"></el-table-column>
        <el-table-column prop="headTeacherBookNum" label="主教课容量"></el-table-column>
        <el-table-column prop="curBookPeople" label="当前预约人数"></el-table-column>
        <el-table-column prop="teachersInfo" label="教练"></el-table-column>
        <el-table-column prop="teachersInfo" label="操作人"></el-table-column>
        <el-table-column prop="remark" label="课程备注"></el-table-column>
        <el-table-column prop="bookStatu" label="预约状态"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize" :page-sizes="queryParam.pageSizes" :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <!--    修改课程信息你-->
    <el-dialog title="修改课程" :visible.sync="visibleDlgUpdate" width="50%" center>
      <!-- <el-form ref="baseRef" :model="selectRow" label-width="140px">
        <el-form-item label="课程名:" prop="title">
          <el-input readonly="true" style="width: 300px" v-model="selectRow.lessonName"></el-input>
        </el-form-item>
        <el-form-item label="教练:" prop="title">
          <el-input readonly="true" style="width: 300px" v-model="selectRow.teachersInfo"></el-input>
        </el-form-item>

        <el-form-item label="总课容量:" prop="title">
          <el-input readonly="true" style="width: 300px" v-model="selectRow.maxBookPeople"></el-input>
        </el-form-item>
        <el-form-item label="主教课容量:" prop="title">
          <el-input readonly="true" style="width: 300px" v-model="selectRow.headTeacherBookNum"></el-input>
        </el-form-item>

        <el-form-item label="修改主教:" prop="title">
          <el-select v-model="updateParam.headTeacher" placeholder="请选择">
            <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改助教:" prop="title">
          <el-select v-model="updateParam.assistantTeacher" placeholder="请选择">
            <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改总课容量:" prop="title">
          <el-input style="width: 300px" v-model="updateParam.maxBookPeople"></el-input>
        </el-form-item>
        <el-form-item label="修改主教课容量:" prop="title">
          <el-input style="width: 300px" v-model="updateParam.headTeacherBookNum"></el-input>
        </el-form-item>
      </el-form> -->
      <div>
        <el-form ref="registerRef" label-width="150px">
          <div style="display: flex;">
            <el-form-item label="课程名:" style="width: 42%;">
              <el-input v-model="temporary.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="上课时间:">
              <el-time-picker style="width: 150px" disabled v-model="temporary.classStartTime" format="HH:mm"
                value-format="HHmm" :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="上课时间">
              </el-time-picker>
              <span>-</span>
              <el-time-picker style="width: 150px" disabled v-model="temporary.classEndTime" format="HH:mm"
                value-format="HHmm" :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="下课时间">
              </el-time-picker>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="课程选择:" style="width: 42%;">
              <el-select v-model="temporary.storeLessonId" placeholder="请选择" disabled>
                <el-option v-for="item in qlLeveList" :key="item.id" :label="item.lessonName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="教师:">
              <el-select v-model="temporary.classroomId" placeholder="请选择" disabled>
                <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="课容量(总):" style="width: 42%;">
              <el-input-number v-model="temporary.maxBookPeopleCopy" disabled></el-input-number>
            </el-form-item>
            <el-form-item label="课容量(助):">
              <el-input-number v-model="temporary.assistantCapacityCopy" disabled></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="主教师:">
              <el-select v-model="temporary.headTeacher" placeholder="请选择">
                <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
          </div>
          <div style="display: flex;">

            <el-form-item label="修改客容量(总):" style="width: 42%;">
              <el-input-number v-model="temporary.maxBookPeople"></el-input-number>
            </el-form-item>
            <el-form-item label="修改客容量(助):">
              <el-input-number v-model="temporary.assistantCapacity"></el-input-number>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="修改教师(总):">
              <el-select v-model="temporary.headTeacher" placeholder="请选择">
                <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="修改老师(助):">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="display: flex;align-items: center;margin-bottom: 10px;"
                  v-for="(v, index) in temporary.teaching">
                  <el-select v-model="v.assistant" placeholder="请选择">
                    <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                  <img v-if="index == 0" src="../../../../statics/imgs/jh.png" alt="" @click="clickjj"
                    style="width: 25px;margin-left: 10px;height: 25px;margin-right: 40px;">
                  <img v-else src="../../../../statics/imgs/jih.png" alt="" @click="clickjs(index)"
                    style="margin-right: 40px;width: 25px;margin-left: 10px;height: 25px;">
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgUpdate = false">取消</el-button>
        <el-button type="primary" @click="onBtnUpdate()">确认</el-button>
      </span>
    </el-dialog>


    <!-- 加课 -->
    <el-dialog :title="title" :visible.sync="visibleDlgAdd" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <div style="display: flex;">
            <el-form-item label="日期选择:" style="width: 42%;">
              <el-date-picker disabled value-format="yyyyMMdd" v-model="temporary.dayTime" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="上课时间:">
              <el-time-picker style="width: 150px" v-model="classStartTime" format="HH:mm" value-format="HH:mm" @change='clickChange'
                :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="上课时间">
              </el-time-picker>
              <span>-</span>
              <el-time-picker style="width: 150px" v-model="classEndTime" format="HH:mm" value-format="HH:mm"
                :picker-options="{ selectableRange: '00:00:00- 23:59:59' }" placeholder="下课时间">
              </el-time-picker>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="课程选择:" style="width: 42%;">
              <el-select v-model="temporary.storeLessonId" placeholder="请选择">
                <el-option v-for="item in qlLeveList" :key="item.id" :label="item.lessonName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="位置:">
              <el-select v-model="temporary.classroomId" placeholder="请选择">
                <el-option v-for="item in selectAllList" :key="item.id" :label="item.classroomName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="总课容量:" style="width: 42%;">
              <el-input-number v-model="temporary.maxBookPeople"></el-input-number>
            </el-form-item>
            <el-form-item label="主教师:">
              <el-select v-model="temporary.headTeacher" placeholder="请选择">
                <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex;">

            <el-form-item label="教师(主)容量:">
              <el-input-number v-model="temporary.headTeacherBookNum"></el-input-number>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="助教:">
              <div style="display: flex;flex-wrap: wrap;">
                <div style="display: flex;align-items: center;margin-bottom: 10px;"
                  v-for="(v, index) in temporary.teaching" :key="index">
                  <el-select v-model="v.assistant" placeholder="请选择">
                    <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                  <img v-if="index == 0" src="../../../../statics/imgs/jh.png" alt="" @click="clickjj"
                    style="width: 25px;margin-left: 10px;height: 25px;margin-right: 40px;">
                  <img v-else src="../../../../statics/imgs/jih.png" alt="" @click="clickjs(index)"
                    style="margin-right: 40px;width: 25px;margin-left: 10px;height: 25px;">
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="warning" @click="handleAddOne()">添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


import { fechListReleaseLesson, revokeLesson, updateReleaseLessonInfo, correctBookNum } from "../../../../api/StoreReleaseLesson";
import { storeReleaseDetail, verify, qlLevelLesson, selectAllGET, temporaryReleaseLesson } from "../../../../api/scheduleTimeTemplate";
import messageUtils from "../../../../utils/messageUtils";
import globaldata from "../../../../utils/globaldata";
import commonUtils from "../../../../utils/commonUtils";
import enumsUtil from "../../../../utils/enumsUtil";
import timeUtils from "../../../../utils/timeUtils";
import { formatDate } from "../../../../utils/date";

export default {
  name: 'ReleaseLessonRecordFc',
  props: {
    allWorker: Array,
  },
  data() {
    return {
      idsnt: 1,
      title: '加课',
      qlLeveList: [],//查询当前门店课程
      selectAllList: [], // 查询当前门店教室
      addData: {
        maxNum: 0,//最大人数
        addTime: {
          start: "",
          end: ""
        },
        optionsLessonValue: "",
        lessonTemplateBussnessId: "",//课程业务 亲子游 基础游
        workers: [],
      },
      classStartTime:'',
      classEndTime:'',
      temporary: {
        dayTime: '', // 日期
        classStartTime: '', //上课时间
        classEndTime: '', //下课时间
        storeLessonId: "",//课程选择
        classroomId: '',//位置
        maxBookPeople: 0, // 总课容量
        headTeacher: '',//主教师
        headTeacherBookNum: 0,//教师(主)容量
        teaching: [{ // 助教
          assistant: ''
        }]
      },
      //店铺等级课程
      storeLevelLesson: [],
      visibleDlgAdd: false, // 临时加课
      week: [
        { lable: '周一', value: 1 },
        { lable: '周二', value: 2 },
        { lable: '周三', value: 3 },
        { lable: '周四', value: 4 },
        { lable: '周五', value: 5 },
        { lable: '周六', value: 6 },
        { lable: '周日', value: 7 },
      ],
      redioWeek: [
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '周三' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { ay: 0, weekDay: '' },
        { day: 0, weekDay: '' },
        { day: 0, weekDay: '' },
      ],
      radio: '',
      curDay: "",//当前日期
      redioDay: null,
      checkedDay: [],
      listLoading: false,
      //弹窗临时加课
      visibleDlgAdd: false,
      visibleRevoke: false,
      visibleDlgDelete: false,
      visibleDlgUpdate: false,
      //查询参数
      queryParam: {
        storeFrontId: "",
        storeLessonId: '',
        dayTime: '',

        storeLessonCardsQuary: [

        ],

        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],

      },

      selectRow: "",
      updateParam: {
        teachersInfo: "",
        maxBookPeople: 0,
        headTeacher: "",
        assistantTeacher: "",
        headTeacherBookNum: ""
      },


      //表单结果
      tableData: [
      ],
      storeLessonCards: [],

      //添加参数
      createParam: {

      },

    }
  },
  created() {
    this.calRedioDay()
  },
  mounted() {

  },
  methods: {
    clickChange(e){
      console.log(e,'eeeeeeeeeeeeeeeeeee')
    },
    // 添加
    handleAddOne() {
      if (this.temporary.dayTime == '') {
        messageUtils.errorMsg(this, "请先选择日期选择");
        return
      } else if (this.classStartTime == '' || this.classEndTime == '') {
        messageUtils.errorMsg(this, "请先选择上课时间");
        return
      } else if (this.temporary.storeLessonId == '') {
        messageUtils.errorMsg(this, "请先选择课程");
        return
      } else if (this.temporary.maxBookPeople == '') {
        messageUtils.errorMsg(this, "请先选总课容量");
        return
      } else if (this.temporary.headTeacher == '') {
        messageUtils.errorMsg(this, "请先选择主教师");
        return
      } else if (this.temporary.headTeacherBookNum == '') {
        messageUtils.errorMsg(this, "请先选择教师(主)容量");
        return
      }
      let headTeacher = ''

      this.temporary.teaching.forEach((item) => {
        if (item.assistant != '') {
          headTeacher = headTeacher ? headTeacher + ',' + item.assistant : item.assistant
        }
      })
      let dayTime = null;
      if (commonUtils.isObjectNull(this.redioDay)) {
        let now = new Date();
        this.redioDay = formatDate(now, 'yyyy-MM-dd')
        dayTime = timeUtils.transDayInt(this.redioDay);
      } else {
        // let nowStr= formatDate(day, 'yyyy-MM-dd')
        dayTime = timeUtils.transDayInt(this.redioDay);
      }
      this.temporary.dayTime = dayTime
      let classStartTime = timeUtils.transTimeHMInt(this.classStartTime)
      let classEndTime = timeUtils.transTimeHMInt(this.classEndTime)
      this.$set(this.temporary,'classStartTime',classStartTime)
      this.$set(this.temporary,'classEndTime',classEndTime)
      // console.log(dayTime,'dayTime=======')
      // return
      // this.temporary.classStartTime = Number(this.temporary.classStartTime)
      // this.temporary.classEndTime = Number(this.temporary.classEndTime)
      verify({ headTeacher: this.temporary.headTeacher, assistantTeacher: headTeacher }).then((res) => {
        if (res.code == 20000) {
          this.temporaryRe()
        }
      })
      console.log(this.temporary, 'temporary=========')
    },
    // 临时加课
    temporaryRe() {
      temporaryReleaseLesson({ ...this.temporary, storeFrontId: globaldata.getAdminStore().storeFrontId, releaseAdminId: globaldata.getAdminStore().id, }).then((res) => {
        if (res.code == 20000) {
          console.log(this.temporary,'this.temporary============1111111')
        this.classStartTime = ''
         this.classEndTime = ''
          messageUtils.successMsg(this, "新增成功")

          this.flechList();
          this.visibleDlgAdd = false
        }
      })
    },
    //修改课程
    updateRelease() {
      updateReleaseLessonInfo({ ...this.temporary, storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "修改成功")
          this.flechList();
          this.visibleDlgUpdate = false
        }
      })
    },
    // 查询课程详情
    storeRelease() {
      storeReleaseDetail({ id: this.selectRow.id }).then((res) => {
        if (res.code == 20000) {
          this.temporary = res.data
          this.temporary.classStartTime = JSON.stringify(this.temporary.classStartTime)
          this.temporary.dayTime = JSON.stringify(this.temporary.dayTime)
          this.temporary.classEndTime = JSON.stringify(this.temporary.classEndTime)
          this.temporary.storeLessonId = this.temporary.storeLevelLessonId
          this.temporary.classroomId = this.temporary.headTeacher

          console.log(this.temporary, '============')
          // this.title = '修改课程'
          this.visibleDlgUpdate = true
        }
      })
    },
    // 增加助教
    clickjj() {
      this.temporary.teaching.push({ assistant: '' })
    },
    // 减少助教
    clickjs(index) {
      console.log(index, '=======')
      // this.course.teaching.push({ assistant: '' })
      this.$delete(this.temporary.teaching, index, 1)
    },
    calRedioDay() {
      let nowDay = new Date();
      let dm = timeUtils.getDayMilSec();
      for (let i = 0; i < this.redioWeek.length; ++i) {
        let dayTime = nowDay.getTime() + (dm) * i;
        let date = new Date(dayTime);
        this.redioWeek[i].day = formatDate(date, 'yyyy-MM-dd');
        let weekDay = timeUtils.getWeekDay(date);
        this.redioWeek[i].weekDay = weekDay;
      }
    },
    //查询当前门店课程
    qlLevel() {
      qlLevelLesson({ storeFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        // console.log(res, 'res================')
        if (res.code == 20000) {
          this.qlLeveList = res.data
        }
      })
    },
    //查询当前门店教室
    selectAll() {
      selectAllGET({ shopFrontId: globaldata.getAdminStore().storeFrontId }).then((res) => {
        // console.log(res, 'res================')
        if (res.code == 20000) {
          this.selectAllList = res.data
        }
      })
    },
    changesd(v) {
      this.idsnt = 1
      this.radio = ''
      this.redioDay = this.queryParam.dayTime
    },
    checkedDayChanged(val) {

      let day = this.redioWeek[val].day;
      this.redioDay = day;

      this.fechListUserBookLesson(day);
    },
    fechListUserBookLesson(day) {

      this.listLoading = true;

      let dayTime = null;
      if (commonUtils.isObjectNull(day)) {
        let now = new Date();
        day = formatDate(now, 'yyyy-MM-dd')
        dayTime = timeUtils.transDayInt(day);
        this.curDay = day;
      } else {
        // let nowStr= formatDate(day, 'yyyy-MM-dd')
        dayTime = timeUtils.transDayInt(day);
        this.curDay = day;
      }
      this.idsnt = 2
      this.queryParam.dayTime = ''
      this.flechList();
      console.log(this.curDay, ' this.curDay=============')
      return
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeReleaseLessonId: this.queryParam.storeReleaseLessonId,
        userPhone: this.queryParam.userPhone,
        childName: this.queryParam.userChildrenName,
        childPetName: this.queryParam.userChildrenPetName,
        bookStatu: this.queryParam.optionsBookStatuValue,
        singIn: this.queryParam.optionsSignStatuValue,
        lessonName: this.queryParam.lessonName,
        dayTime: dayTime,
        lessonTemplateId: enumsUtil.lessonTemplateIdCF(),
        pageNum: this.queryParam.pageNum,//当前第几页
        pageSize: this.queryParam.pageSize
      }

      const loading = this.myLoading();

      fechListReleaseLessonDetail(param).then(response => {
        loading.close();
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        //console.info(date);
        date.forEach(item => {
          if (item.goodsId != null) {
            let goods = item.goodsId;
            goods = goods.toString().split(",");
            let goodsName = "";
            for (var i = 0; i < goods.length; i++) {
              goodsName = goodsName + this.getGoods(goods[i]) + ",";
            }
            //console.info(goodsName);
            item.goodsName = goodsName.toString().replace(/^(\s|,)+|(\s|,)+$/g, '');
          }
        });

        // this.queryParam.totalPage = date.total;
        this.refreshData(date);

      })
    },
    flechList() {
      this.listLoading = true;
      let dayTime;
      if (this.idsnt == 1) {
        dayTime = this.queryParam.dayTime;
      } else {
        dayTime = this.curDay;
      }
      if (commonUtils.isStringNull(dayTime)) {
        dayTime = formatDate(new Date(), 'yyyy-MM-dd')
      }
      dayTime = timeUtils.transDayInt(dayTime);
      console.log("flechList dayTime", dayTime)
      let param = {
        lessonTemplateId: enumsUtil.lessonTemplateIdCF(),
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        dayTime: dayTime,
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize
      }
      fechListReleaseLesson(param).then(response => {
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.queryParam.totalPage = date.total;
        this.refreshData(date.list);

      })
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      let tableDataList = [];
      for (let i = 0; i < list.length; ++i) {

        let bookStatu = "可预约";
        if (list[i].bookStatu == 1) {
          bookStatu = "已撤销"
        }

        // let classStartTime = timeUtils.transDay(list[i].dayTime) + " " + timeUtils.transTimeHM(list[i].classStartTime)
        let classStartTime = timeUtils.transTimeHM(list[i].classStartTime)

        // let classEndTime = timeUtils.transDay(list[i].dayTime) + " " + timeUtils.transTimeHM(list[i].classEndTime)
        let classEndTime = timeUtils.transTimeHM(list[i].classEndTime)

        let data = {
          number: i + 1,
          id: list[i].id,
          storeLessonId: list[i].storeLessonId,
          phone: list[i].phone,
          lessonName: list[i].name,
          lessonTemplateId: list[i].lessonTemplateId,
          minBookLevel: list[i].minBookLevel,
          storeFrontId: list[i].storeFrontId,

          classStartTime: classStartTime,
          classEndTime: classEndTime,
          releaseTime: list[i].releaseTime,
          releaseAdminId: list[i].releaseAdminId,
          maxBookPeople: list[i].maxBookPeople,
          headTeacherBookNum: list[i].headTeacherBookNum,
          curBookPeople: list[i].curBookPeople,
          teachersInfo: list[i].teachersInfo,
          remark: list[i].remark,
          bookStatu: bookStatu
        };
        tableDataList.push(data);
      }

      this.tableData = tableDataList;
    },
    rowClick(row, column, event) {
      this.selectRow = row;
    },
    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },
    handleSelectionChange(val) {

    },

    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.flechList();
    },

    // //添加一个
    // handleCreateOne() {
    //   this.visibleDlgAdd = true;
    // },
    showVisibleDlgDelete(index, tableData) {
      this.deleteInfo = {
        number: tableData[index].number,
        id: tableData[index].id,
        lessonName: tableData[index].lessonName,
      }
      this.visibleDlgDelete = true;
    },
    // 临时加课
    clickvisibleDlgAdd() {
      // if(this.radio == ''){
      //   this.redioDay = this.queryParam.dayTime
      // }else{
      //   this.redioDay = this.radio
      // }
      if (this.redioDay === '' || this.redioDay === null) {
        messageUtils.errorMsg(this, "请选择日期")
        return
      }
      this.qlLevel();//查询当前门店课程
      this.selectAll();//查询当前门店教室
      this.temporary = {
        dayTime: this.redioDay, // 日期
        classStartTime: '', //上课时间
        classEndTime: '', //下课时间
        storeLessonId: "",//课程选择
        classroomId: '',//位置
        maxBookPeople: 0, // 总课容量
        headTeacher: '',//主教师
        headTeacherBookNum: 0,//教师(主)容量
        teaching: [{ // 助教
          assistant: ''
        }]
      },
      console.log(this.temporary,'this.temporary========')
        this.title = '加课'
      this.visibleDlgAdd = true
    },
    showVisibleDlgUpdateLesson() {
      this.qlLevel();//查询当前门店课程
      this.selectAll();//查询当前门店教室
      if (commonUtils.isStringNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请选择一条数据")
        return;
      }
      this.storeRelease()
      console.log(this.selectRow, 'this.selectRow====')
      return
      this.updateParam.teachersInfo = this.selectRow.teachersInfo;
      this.updateParam.maxBookPeople = this.selectRow.maxBookPeople;
      this.updateParam.headTeacher = this.selectRow.headTeacher;
      this.updateParam.assistantTeacher = this.selectRow.assistantTeacher;
      this.updateParam.headTeacherBookNum = this.selectRow.headTeacherBookNum;
      this.visibleDlgUpdate = true;
    },

    onBtnUpdate() {
      let headTeacher = ''

      this.temporary.teaching.forEach((item) => {
        if (item.assistant != '') {
          headTeacher = headTeacher ? headTeacher + ',' + item.assistant : item.assistant
        }
      })
      if (Number(this.temporary.maxBookPeople) < Number(this.temporary.assistantCapacity)) {
        messageUtils.errorMsg(this, "客容量(助)不能大约客容量(总)");
        return
      }
      this.temporary.classStartTime = Number(this.temporary.classStartTime)
      this.temporary.classEndTime = Number(this.temporary.classEndTime)
      verify({ headTeacher: this.temporary.headTeacher, assistantTeacher: headTeacher }).then((res) => {
        if (res.code == 20000) {
          this.updateRelease()
        }
      })
      return
      let param = {
        id: this.selectRow.id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        maxBookPeople: this.updateParam.maxBookPeople,
        headTeacher: this.updateParam.headTeacher,
        assistantTeacher: this.updateParam.assistantTeacher,
        headTeacherBookNum: this.updateParam.headTeacherBookNum,
      }
      const loading = this.myLoading("正在修改中,请稍后");
      updateReleaseLessonInfo(param).then(response => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        messageUtils.successMsg(this, response.message)
        this.visibleDlgUpdate = false;
        this.flechList();

      })
    },

    handleRevoke() {

      if (commonUtils.isStringNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请选择一条数据")
        return;
      }
      let param = {
        id: this.selectRow.id,
        adminId: globaldata.getAdminStore().id
      }
      const loading = this.myLoading("正在撤销中,请稍后");
      revokeLesson(param).then(response => {
        loading.close();
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "撤销成功")
        this.flechList();

      })

    },

    correctBookNum() {

      if (commonUtils.isStringNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请选择一条数据")
        return;
      }
      let param = {
        id: this.selectRow.id
      }
      const loading = this.myLoading("操作中,请稍后");
      correctBookNum(param).then(response => {
        loading.close();
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "成功")
        this.flechList();

      })

    },


    onBtnOK() {
      this.visibleDlgAdd = false;
    },
    onBtnCancel() {
      this.visibleDlgAdd = false;
    },

    handleUpdate() {
      this.visibleDlgupdate = false;
    },

  }
}
</script>

<style scoped>
/deep/ .el-table th.el-table__cell>.cell {
  width: 90%;
  height: auto;
  background: #ecf3fd;
  border-radius: 8px;
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
</style>




// WEBPACK FOOTER //
// src/views/my-store/scheduling-template/components/ReleaseLessonRecordFc.vue